<input [id]="inputId" class="feInput bigText" (input)="valueChange.emit(inputValue)" [name]="name"
       [type]="type" [(ngModel)]="inputValue" placeholder="{{placeHolder}}" [required]="required"
       [email]="email" [disabled]="disabled" [readonly]="readonly" [class.feInputIcon]="icon != null"
       style="min-width: {{width}};cursor: {{cursor}};" [class.lightBlackC]="color === ColorType.lightBlack" [class.smallMode]="smallMode"
       [class.darkGreyC]="color === ColorType.darkGrey" #inputElement>
<fe-icon *ngIf="icon" [iconType]="icon" [size]="18" [color]="color"/>
